export default "__VITE_ASSET__D33znMBP__"